import { useEffect } from 'react';
import axios from '../../services/api-axios';
import OnlineUsers from './OnlineUsers';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { set } from '../../store/onlineUsersSlice';
import styles from './OnlineUsersWrapper.module.css';

interface OnlineUsersWrapperProps {
    lobbyId?: string;
}

const OnlineUsersWrapper = ({ lobbyId }: OnlineUsersWrapperProps) => {
    const onlineUsers = useAppSelector((state) => state.onlineUsers.users);
    const username = useAppSelector((state) => state.profile.username);
    const dispatch = useAppDispatch();

    useEffect(() => {
        axios.get('/rest/participants')
            .then(response => {
                dispatch(set(response.data.usernames.filter((uname: string) => uname !== username)));
            })
            .catch(error => {
                console.error(error);
            });
    }, [username]);

    return (
        <div className={styles.panel}>
            <div className={styles.header}>
                <h3 className={styles.title}>👥 Online Users</h3>
                <div className={styles.countPill}>
                    <div className={styles.pulseDot} />
                    {onlineUsers.length} online
                </div>
            </div>

            {onlineUsers.length === 0 ? (
                <div className={styles.emptyState}>
                    <div className={styles.emptyIcon}>😴</div>
                    <h4 className={styles.emptyTitle}>No Users Online</h4>
                    <p>Waiting for friends to join...</p>
                </div>
            ) : (
                <OnlineUsers users={onlineUsers} lobbyId={lobbyId} />
            )}
        </div>
    );
};

export default OnlineUsersWrapper;
